module.exports = __webpack_public_path__ + "static/images/shield.b4b037e843e87c0053a9584389a16520.svg";